import { I18nContext } from '@sqs/i18n-react';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

export const WrappedRouter = () => {
  return (
    <I18nContext.Provider
      value={{
        translationLocale: __LOCALE__,
        formattingLocale: __LOCALE__,
      }}
    >
      <RouterProvider router={router} />
    </I18nContext.Provider>
  );
};
